import script from "./IconSvg.vue?vue&type=script&setup=true&lang=js"
export * from "./IconSvg.vue?vue&type=script&setup=true&lang=js"

import "./IconSvg.vue?vue&type=style&index=0&id=7354f8ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7354f8ee"]])

export default __exports__